export default __webpack_public_path__ + "static/media/app-store.a71d7da7.svg";